import clamp from "lodash/clamp";
import { AVAILABILITY_THRESHOLD_STEP } from "PFComponents/availability/threshold_slider";
import { InputFocusProps } from "PFComponents/table/interactive/use_cell_input_focus";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { AvailabilityRule } from "PFCore/types";
import { FocusEvent, RefObject } from "react";

import css from "../../../tabular_roles_form.module.scss";

const snapToStep = (value: number, step: number): number => Math.round(value / step) * step;

type AvailabilityThresholdCellProps = {
  availability: AvailabilityRule | null;
  onChange: (availability: AvailabilityRule | null) => void;
  disabled?: boolean;
  error?: string;
  inputFocusProps?: InputFocusProps;
  ref?: RefObject<HTMLInputElement>;
};

export const AvailabilityThresholdCell = ({
  availability,
  onChange,
  disabled,
  error,
  inputFocusProps,
  ref
}: AvailabilityThresholdCellProps) => (
  <InputFieldSet
    ref={ref}
    inputClassName={css.singleLineInput}
    inputType="number"
    min={0}
    max={100}
    variant="table"
    value={availability?.availability_threshold}
    disabled={disabled}
    error={error}
    onChange={(value) =>
      onChange({
        ...availability,
        availability_threshold: clamp(Number(value), 0, 100)
      } as AvailabilityRule)
    }
    onBlur={(event: FocusEvent<HTMLInputElement>) =>
      onChange({
        ...availability,
        availability_threshold: snapToStep(Number(event.target.value), AVAILABILITY_THRESHOLD_STEP)
      } as AvailabilityRule)
    }
    {...inputFocusProps}
  />
);
